import { $, $$ } from '../helpers/selectors';

const SELECTOR = '.grid-module';

class GridModule {
  constructor() {
    if (! $(SELECTOR)) {
      return false;
    }

    $$(SELECTOR).forEach(section => {
      // let titleMinHeight = 0;
      // const titles = $$('.grid-module__content-heading', section);
      const viewMoreLink = $('.js-grid-view-more', section);
      const itemArr = [];
      let clickCounter = 7;
      let currClickCounter = 0;
      let viewItems = ($$('.grid-module__item', section).length - 6);
      const heightsArr = [];

      $$('.grid-module__item', section).forEach(item => {
        itemArr.push(item);
        const title = $('.grid-module__content-heading', item);

        heightsArr.push(title.offsetHeight);

        setTitleHeights(itemArr, Math.max(...heightsArr));
      });

      $('.js-grid-view-more-text', viewMoreLink).innerHTML = `View ${ (viewItems) } more`;

      if ($$('.grid-module__item', section).length <= 6) {
        $('.js-grid-view-more', section).classList.add('is-hidden');
      }

      $('.js-grid-view-more', section).addEventListener('click', e => {
        e.preventDefault();
        currClickCounter = clickCounter;
        for (let step = 1; step <= 6; step++) {
          if (clickCounter <= $$('.grid-module__item', section).length) {
            $(`.grid-module__item:nth-child(${ clickCounter })`, section).classList.add('is-visible');
            clickCounter++;
          } else {
            $('.js-grid-view-more', section).classList.add('is-hidden');
          }
        }

        viewItems = viewItems - 6;

        $('.js-grid-view-more-text', viewMoreLink).innerHTML = `View ${ (viewItems) } more`;
        doScrolling(((window.pageYOffset - 60) + $(`.grid-module__item:nth-child(${ currClickCounter })`, section).getBoundingClientRect().top), 1000);
      });
    });

    /* eslint-disable */
    function doScrolling(elementY, duration) {
      const startingY = window.pageYOffset;

      // If element is close to page's bottom then window will scroll only to some position above the element.
      const targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
      const diff = targetY - startingY;
      // Easing function: easeInOutCubic
      // From: https://gist.github.com/gre/1650294
      const easing = function(t) {
        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      };
      let start;

      if (! diff) {
        return;
      }

      // Bootstrap our animation - it will get called right before next frame shall be rendered.
      window.requestAnimationFrame(function step(timestamp) {
        if (! start) {
          start = timestamp;
        }
        // Elapsed miliseconds since start of scrolling.
        const time = timestamp - start;
        // Get percent of completion in range [0, 1].
        let percent = Math.min(time / duration, 1);
        // Apply the easing.
        // It can cause bad-looking slow frames in browser performance tool, so be careful.
        percent = easing(percent);

        window.scrollTo(0, startingY + diff * percent);

        // Proceed with animation as long as we wanted it to.
        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      });
    }
  /* eslint-enable */

    function setTitleHeights(items, titleMinHeight) {
      items.forEach(gridItem => {
        $('.grid-module__content-heading', gridItem).style.minHeight = titleMinHeight + 'px';
      });
    }
  }
}

export default GridModule;
